import {
  LayoutDashboard, ClipboardList, FileText, ArrowDownToLine, ArrowUpFromLine,
  Users, MapPin, FileBarChart, Bot, ShieldCheck, Radar, PackageCheck, Layers,
  ShieldAlert, Factory, Contact, Eye, Briefcase, UsersRound, FolderKanban, Receipt,
  Repeat, Siren, Command, LayoutTemplate, CalendarDays, Hourglass, Package,
  FlaskConical, Warehouse, Wrench,
  DatabaseZap, Search, Tags, PackageSearch, RefreshCw,
  Sunrise, Moon, ClipboardCheck, BadgeCheck, Gauge, Bell, Archive, Settings,
  HeartPulse, UserRoundPlus, ScanLine, CalendarRange,
} from "lucide-react";

const OPS_FLOOR = ["admin", "warehouse_manager", "supervisor", "worker", "dispatch"];
const OFFICE = ["*"];

export const NAV_GROUPS = [
  {
    section: null,
    items: [
      { to: "/", label: "My Dashboard", icon: LayoutDashboard, roles: ["*"] },
      { to: "/my-work", label: "My Work (All)", icon: ClipboardList, roles: ["*"] },
      { to: "/who-is-responsible", label: "Who Is Responsible", icon: UsersRound, roles: ["admin", "director", "operations_head", "finance_head", "hr", "sales_head", "factory_head", "warehouse_manager", "supervisor", "accounts_manager", "dispatch_manager", "sales_manager", "production_manager", "quality_head", "ppc_head"] },
    ],
  },
  {
    section: "Control Towers",
    items: [
      { to: "/ops-dashboard", label: "Operations Command", icon: LayoutDashboard, roles: ["admin", "warehouse_manager", "supervisor"] },
      { to: "/command-center", label: "Command Center", icon: Command, roles: ["admin", "warehouse_manager"] },
      { to: "/control-tower", label: "Control Tower", icon: Radar, roles: ["admin", "warehouse_manager", "supervisor"] },
      { to: "/sales-tower", label: "Sales Tower", icon: Eye, roles: ["admin", "warehouse_manager", "supervisor", "sales"] },
    ],
  },
  {
    section: "Task Management",
    items: [
      { to: "/tm", label: "All Tasks", icon: ClipboardList, roles: OFFICE },
      { to: "/tm/my", label: "My Tasks", icon: Briefcase, roles: OFFICE },
      { to: "/tm/team", label: "Team Tasks", icon: UsersRound, roles: OFFICE },
      { to: "/tm/standup", label: "Stand-up", icon: Sunrise, roles: OFFICE },
      { to: "/tm/eod", label: "EOD Report", icon: Moon, roles: OFFICE },
      { to: "/tm/daily-review", label: "Daily Review", icon: ClipboardCheck, roles: OFFICE },
      { to: "/tm/approvals", label: "Approvals", icon: BadgeCheck, roles: OFFICE },
      { to: "/tm/escalations", label: "Escalations", icon: Siren, roles: OFFICE },
      { to: "/tm/control-tower", label: "MD Control Tower", icon: Gauge, roles: ["admin", "director", "operations_head", "warehouse_manager", "supervisor", "sales_head", "factory_head", "finance_head"] },
      { to: "/tm/reports", label: "Task Reports", icon: FileBarChart, roles: OFFICE },
      { to: "/tm/notifications", label: "Notifications", icon: Bell, roles: ["*"] },
      { to: "/office/projects", label: "Projects", icon: FolderKanban, roles: OFFICE },
      { to: "/office/recurring", label: "Recurring", icon: Repeat, roles: OFFICE },
      { to: "/office/templates", label: "Templates", icon: LayoutTemplate, roles: OFFICE },
      { to: "/reimbursements", label: "Reimbursements", icon: Receipt, roles: ["*"] },
      { to: "/office/ageing", label: "Ageing", icon: Hourglass, roles: OFFICE },
      { to: "/tm/archive", label: "Archive (Admin)", icon: Archive, roles: ["admin"] },
      { to: "/tm/settings", label: "Workflow Settings", icon: Settings, roles: ["admin"] },
    ],
  },
  {
    section: "HR & Workforce Management",
    items: [
      { to: "/hrms", label: "HR Dashboard", icon: HeartPulse, roles: ["admin", "director", "hr", "attendance", "factory_head", "plant_manager", "shift_incharge", "production_supervisor"] },
      { to: "/hrms/employees", label: "Employee Management", icon: UserRoundPlus, roles: ["admin", "director", "hr"] },
      { to: "/hrms/attendance", label: "Attendance & Shifts", icon: ScanLine, roles: ["admin", "director", "hr", "attendance", "factory_head", "plant_manager", "shift_incharge", "production_supervisor"] },
      { to: "/hrms/shifts-leave", label: "Leave Management", icon: CalendarRange, roles: ["*"] },
    ],
  },
  {
    section: "Operations",
    items: [
      { to: "/orders", label: "Order Fulfilment", icon: PackageCheck, roles: ["admin", "warehouse_manager", "supervisor", "sales", "accounts", "production", "qc", "dispatch", "dispatch_manager"] },
      { to: "/production", label: "Productions", icon: Factory, roles: ["admin", "warehouse_manager", "production"] },
      { to: "/factory", label: "Factory", icon: Wrench, roles: ["*"] },
      { to: "/tasks", label: "Tasks", icon: ClipboardList, roles: ["*"] },
      { to: "/inward", label: "Inward", icon: ArrowDownToLine, roles: ["admin", "warehouse_manager", "supervisor"] },
      { to: "/outward", label: "Dispatch", icon: ArrowUpFromLine, roles: ["admin", "warehouse_manager", "supervisor", "dispatch", "dispatch_manager"] },
      { to: "/exceptions", label: "Exceptions", icon: ShieldAlert, roles: ["admin", "warehouse_manager", "supervisor", "qc", "accounts", "production"] },
      { to: "/samples", label: "Samples", icon: FlaskConical, roles: ["admin", "warehouse_manager", "supervisor", "worker", "qc", "dispatch", "sales"] },
    ],
  },
  {
    section: "Product Hub",
    items: [
      { to: "/hub/dashboard", label: "Hub Dashboard", icon: LayoutDashboard, roles: ["admin", "warehouse_manager", "supervisor", "sales", "accounts", "production", "qc", "dispatch"] },
      { to: "/hub", label: "Product Search", icon: Search, roles: ["admin", "warehouse_manager", "supervisor", "sales", "accounts", "production", "qc", "dispatch"] },
      { to: "/hub/applications", label: "Application Master", icon: Tags, roles: ["admin", "warehouse_manager", "supervisor", "sales", "accounts", "production", "qc", "dispatch"] },
      { to: "/hub/stock-requests", label: "Stock Requests", icon: PackageSearch, roles: ["admin", "warehouse_manager", "supervisor", "sales", "accounts", "production", "qc", "dispatch"] },
      { to: "/hub/replenishment", label: "Replenishment (SCM)", icon: RefreshCw, roles: ["admin", "warehouse_manager", "accounts"] },
    ],
  },
  {
    section: "Business",
    items: [
      { to: "/bills", label: "Bills", icon: FileText, roles: ["admin", "warehouse_manager", "supervisor", "dispatch"] },
      { to: "/stock", label: "Stock & Reservations", icon: Layers, roles: ["admin", "warehouse_manager", "supervisor", "worker", "sales", "accounts", "production", "qc", "dispatch"] },
      { to: "/products", label: "Products & Pricing", icon: Package, roles: ["admin", "warehouse_manager", "supervisor", "sales", "accounts"] },
      { to: "/customers", label: "Customers", icon: Contact, roles: ["admin", "warehouse_manager", "supervisor", "sales", "accounts"] },
      { to: "/reports", label: "Reports", icon: FileBarChart, roles: ["admin", "warehouse_manager"] },
    ],
  },
  {
    section: "Administration",
    items: [
      { to: "/workers", label: "Workers", icon: Users, roles: ["admin", "warehouse_manager", "supervisor"] },
      { to: "/warehouses", label: "Warehouses", icon: Warehouse, roles: ["admin", "warehouse_manager", "supervisor", "sales", "accounts", "dispatch", "qc"] },
      { to: "/locations", label: "Locations", icon: MapPin, roles: ["admin", "warehouse_manager", "supervisor"] },
      { to: "/users", label: "Users", icon: ShieldCheck, roles: ["admin"] },
      { to: "/roles", label: "Roles & Permissions", icon: ShieldAlert, roles: ["admin"] },
      { to: "/data-reset", label: "Data Reset", icon: DatabaseZap, roles: ["admin"] },
    ],
  },
  {
    section: null,
    items: [
      { to: "/assistant", label: "AI Assistant", icon: Bot, roles: ["admin", "warehouse_manager", "supervisor", "worker", "dispatch"] },
    ],
  },
];

export const NAV = NAV_GROUPS.flatMap((g) => g.items);

export const ROLE_LABELS = {
  admin: "Admin / MD",
  warehouse_manager: "Manager",
  supervisor: "Supervisor",
  worker: "Worker",
  dispatch: "Dispatch",
  sales: "Sales",
  accounts: "Accounts",
  production: "Production",
  qc: "QC",
};
